import { ToggleButton, ToggleButtonGroup, styled } from "@mui/material";

import React from "react";

function ToggleView({ onChange, value }) {
  const handleChange = (event, newAlignment) => {
    if (newAlignment) {
      onChange(newAlignment);
    }
  };

  return (
    <ToggleButtonGroupStyle
      color="secondary"
      value={value}
      exclusive
      onChange={handleChange}
      aria-label="Platform"
    >
      <ToggleButtonStyle value="list">
        <ion-icon name="list"></ion-icon>
      </ToggleButtonStyle>

      <ToggleButtonStyle value="box">
        <ion-icon name="apps"></ion-icon>
      </ToggleButtonStyle>
    </ToggleButtonGroupStyle>
  );
}

const ToggleButtonGroupStyle = styled(ToggleButtonGroup)(() => ({
  background: "transparent",
}));

const ToggleButtonStyle = styled(ToggleButton)(({ theme }) => ({
  border: "none",
  borderRadius: "5px !important",
  color: theme.palette.text.main,
}));

export default ToggleView;
